import { STORIES_ADMIN_PRIVILEGE } from '@opengov/stories-shared/constants';

import { hasPrivilege } from '../../utils';

import { useCurrentSubjectClaims, UseCurrentSubjectClaimsParams } from './useCurrentSubjectClaims';

export function useHasAdminPrivilege(params: UseCurrentSubjectClaimsParams): boolean {
  const { data: currentSubjectClaims } = useCurrentSubjectClaims(params);
  return hasPrivilege(currentSubjectClaims ?? null, STORIES_ADMIN_PRIVILEGE);
}
